"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as r, jsx as l } from "react/jsx-runtime";
import { useTheme as n } from "../../hooks.js";
import { useIsInverseOrMediaVariant as v } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: c, size: a = 24 } = _param, e = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const i = v(), h = c !== null && c !== void 0 ? c : i ? o.colors.inverse : o.colors.neutralHigh, { skinName: t } = n();
    return t.match(/^o2-new/i) ? /* @__PURE__ */ r("svg", _object_spread_props(_object_spread({
        width: a,
        height: a,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: [
            /* @__PURE__ */ l("path", {
                fill: h,
                d: "M9.533 7.355a.713.713 0 0 0-.706.716v10.354c0 .392.316.716.706.716a.71.71 0 0 0 .707-.716V8.07a.716.716 0 0 0-.707-.716M13.763 8.07v10.355c0 .392.316.716.707.716a.71.71 0 0 0 .707-.716V8.07a.713.713 0 0 0-.707-.716.713.713 0 0 0-.707.716"
            }),
            /* @__PURE__ */ l("path", {
                fill: h,
                d: "M15.177 4.5h5.64a.713.713 0 0 1 .004 1.427h-1.41v13.93c0 1.18-.952 2.143-2.117 2.143H6.714c-1.165 0-2.117-.964-2.117-2.144V5.931h-1.41a.71.71 0 0 1-.707-.716c0-.396.32-.715.707-.715h5.64v-.356c0-1.18.951-2.144 2.116-2.144h2.117c1.165 0 2.117.964 2.117 2.144zm-4.23-1.072a.713.713 0 0 0-.707.716h.004V4.5h3.527v-.356a.713.713 0 0 0-.707-.716zm7.05 16.424V5.927H6.007v13.925c0 .396.32.716.707.716H17.29a.713.713 0 0 0 .707-.716"
            })
        ]
    })) : t.match(/^o2/i) ? /* @__PURE__ */ r("svg", _object_spread_props(_object_spread({
        width: a,
        height: a,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: [
            /* @__PURE__ */ l("path", {
                fill: h,
                d: "M9.534 7.355a.713.713 0 0 0-.707.716v10.354c0 .392.316.716.707.716a.71.71 0 0 0 .706-.716V8.07a.716.716 0 0 0-.707-.716M13.763 8.07v10.355c0 .392.316.716.707.716a.71.71 0 0 0 .707-.716V8.07a.713.713 0 0 0-.707-.716.713.713 0 0 0-.707.716"
            }),
            /* @__PURE__ */ l("path", {
                fill: h,
                d: "M15.177 4.5h5.64a.713.713 0 0 1 .004 1.427h-1.41v13.93c0 1.18-.952 2.143-2.117 2.143H6.714c-1.165 0-2.117-.964-2.117-2.144V5.931h-1.41a.71.71 0 0 1-.707-.716c0-.396.32-.715.707-.715h5.64v-.356c0-1.18.951-2.144 2.116-2.144h2.117c1.165 0 2.117.964 2.117 2.144zm-4.23-1.072a.713.713 0 0 0-.707.716h.004V4.5h3.527v-.356a.713.713 0 0 0-.707-.716zm7.05 16.424V5.927H6.007v13.925c0 .396.32.716.707.716H17.29a.713.713 0 0 0 .707-.716"
            })
        ]
    })) : /* @__PURE__ */ r("svg", _object_spread_props(_object_spread({
        width: a,
        height: a,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: [
            /* @__PURE__ */ l("path", {
                fill: h,
                d: "M10 10.25a.75.75 0 0 1 .743.648l.007.102v6a.75.75 0 0 1-1.493.102L9.25 17v-6a.75.75 0 0 1 .75-.75M14.743 10.898A.75.75 0 0 0 13.25 11v6l.007.102A.75.75 0 0 0 14.75 17v-6z"
            }),
            /* @__PURE__ */ l("path", {
                fill: h,
                d: "M16.745 4.447C16.667 3.23 15.702 2.25 14.5 2.25h-5l-.155.006C8.165 2.339 7.25 3.37 7.25 4.607V6.25H3l-.102.007A.75.75 0 0 0 3 7.75h1.25V18.5a3.25 3.25 0 0 0 3.25 3.25h9a3.25 3.25 0 0 0 3.25-3.25V7.75H21l.102-.007A.75.75 0 0 0 21 6.25h-4.25V4.607zM15.25 6.25h-6.5V4.607l.006-.11c.048-.43.373-.747.744-.747h5l.092.006c.361.052.658.404.658.851zm-9.5 1.5h12.5V18.5a1.75 1.75 0 0 1-1.75 1.75h-9l-.144-.006A1.75 1.75 0 0 1 5.75 18.5z"
            })
        ]
    }));
}, p = s;
export { p as default };
